import { useMemo } from 'react';
import { generateErrorLogger } from '~/utilities/loggers';

const useErrorLogger = (
  location: string,
  context?: {
    [key: string]: any;
  }
) => useMemo(() => generateErrorLogger(location, context), [context, location]);

export default useErrorLogger;
